import React, { useState } from 'react';
import { Col, Row, Card, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import SmSectionDropdown from 'components/dropdowns/SkillMatrix/SmSectionDropdown';
import SmAreaDropdown from 'components/dropdowns/SkillMatrix/SmAreaDropdown';
import SmSkillLevelDropdown from 'components/dropdowns/SkillMatrix/SmSkillLevelDropdown';
import MatrixUserDropdown from 'components/dropdowns/SkillMatrix/MatrixUserDropdown'
import { search as searchSkillMatrix } from 'services/skill-matric-services/smSkillMatrixService';

export default function CoreTrainingSetup({ formData, handleFilterChange }) {
  const paramArea = { isGetAll: true, sectionId: formData?.sectionId };

  const [baseParamRequest] = useState({ isGetAll: true });
  const [maxDisplayLevel, setMaxDisplayLevel] = useState(2);

  const hanleFilterInsideChange = async (key, value) => {
    console.log(key, value);
    if (key === 'areaId' || key === 'trainee') {
      const res = await searchSkillMatrix({
        trainee: key === 'trainee' ? value?.userId : formData?.trainee,
        areaId: key === 'areaId' ? value.id : formData?.areaId
      });

      const maxLevel = res?.items?.[0]?.status == 'Complete' ? (res?.items?.[0]?.level + 1 ) : res?.items?.[0]?.level;
      setMaxDisplayLevel(maxLevel || 1);
    }
    handleFilterChange(key, value);
  };

  return (
    <>
      <Col xs={12}>
        <Row className="g-3 mb-3">
          <Col lg={12}>
            <Card className="mb-3">
              <Card.Body className="bg-light">
                <Row style={{ paddingBottom: '10px' }}>
                  <Col md="3">
                    <Form.Group>
                      <Form.Label>Trainee</Form.Label>
                      <MatrixUserDropdown
                        disabled={formData?.id > 0}
                        fieldName="trainee"
                        isMulti={false}
                        handleChange={hanleFilterInsideChange}
                        placeholder="Trainee"
                        value={formData?.trainee}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="3">
                    <Form.Group>
                      <Form.Label>Section</Form.Label>
                      <SmSectionDropdown
                        isDisabled={formData?.id > 0}
                        param={baseParamRequest}
                        handleChange={hanleFilterInsideChange}
                        selectedOptions={formData?.sectionId}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="3">
                    <Form.Group>
                      <Form.Label>Area</Form.Label>
                      <SmAreaDropdown
                        key={formData?.sectionId ?? 0}
                        isDisabled={
                          formData?.sectionId == undefined || formData?.id > 0
                        }
                        param={paramArea}
                        handleChange={hanleFilterInsideChange}
                        selectedOptions={formData?.areaId}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="3">
                    <Form.Group>
                      <Form.Label>Skill Level</Form.Label>
                      <SmSkillLevelDropdown
                        isDisabled={formData?.id > 0}
                        isMulti={false}
                        param={baseParamRequest}
                        handleChange={hanleFilterInsideChange}
                        selectedOptions={formData?.skillLevelId}
                        maxDisplayLevel={maxDisplayLevel}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Col>
    </>
  );
}

CoreTrainingSetup.propTypes = {
  formData: PropTypes.object,
  handleFilterChange: PropTypes.func
};
